module.exports = __webpack_public_path__ + "static/media/MasjidTauheed.8386ddac.png";